import React, { useEffect, useState } from 'react';
import {ADD_ENDPOINT, ENDPOINT,} from '../ISRConstants';
import { DeleteIcon } from 'assests/GmsIcons';
import { TConnector, TField, TIndexState, TProductCategory, TSubmodel, TUpsertISRProjectDataModelsInput } from '../Pages/DefineModel/model';
import ImportSubmodel from '../Pages/DefineModel/Components/ImportSubmodel';

type TConnectorConfigurationsProps = {
    userProjectDataModels: TUpsertISRProjectDataModelsInput;
    selectedItem: TField | TSubmodel | TProductCategory | TConnector | null;
    updateFieldDataConfiguration: (updatedConfig: TConnector) => void;
}

const ConnectorConfigurations = ({userProjectDataModels, selectedItem, updateFieldDataConfiguration}: TConnectorConfigurationsProps) => {
    const initialProductCategory: TConnector = { type: '', id: null, data: { type: '', name: '', isConsumable: true, belongsToDataModel: false, submodels: [], }, };
    const [connectorConfiguration, setConnectorConfiguration] = useState<TConnector | null>(initialProductCategory);

    const [showConnectorMenu, setShowConnectorMenu] = useState<boolean>(false);
    const openConnectorMenu = () => setShowConnectorMenu(true);

    useEffect(() => {
        const connector = selectedItem as TConnector;
        if (connector) {
            setConnectorConfiguration(connector);
        } else {
            setConnectorConfiguration(initialProductCategory);
        }
    }, [selectedItem]);

    const handleDeleteField = (index: number) => {
        setConnectorConfiguration((prevConnector) => {
            if (!prevConnector) {
                return prevConnector;
            }
            const updatedSubmodels = [...prevConnector.data.submodels];
            updatedSubmodels.splice(index, 1);
            return { ...prevConnector, data: { ...prevConnector.data, submodels: updatedSubmodels, }, };
        });
    };

    useEffect(() => {
        if (connectorConfiguration?.data?.submodels?.length === 0) return;
        if (connectorConfiguration) {
            updateFieldDataConfiguration(connectorConfiguration);
        }
    }, [connectorConfiguration]);
    
    return (
        <div className='cart-style-dm'>
            <div className='tw-flex tw-justify-between tw-items-center '>
                <label className='cart-title'>{ENDPOINT}</label>
                <div className='tw-flex tw-flex-wrap tw-items-center'>
                    <button data-testid="components-connectorconfigurations-button-1" className={`btn-outlined tw-text-primary}`} onClick={openConnectorMenu}>{ADD_ENDPOINT}</button>
                    {/* {connectorConfiguration?.data?.submodels ? <button onClick={openConnectorMenu} className='tw-flex tw-items-center tw-p-0'><label className='btn-outlined'>{connectorConfiguration?.data?.submodels?.type ?? ''}</label><NavRightIcon/></button> : null} */}
                </div>
            </div>
            <div>
                {connectorConfiguration?.data?.submodels.map((connector, index) =>
                <div key={connector.id} className='tw-flex tw-items-center tw-gap-2'>
                    <div className='tw-rounded tw-bg-shades-of-grey-0 tw-box-border tw-w-[95%] tw-flex tw-flex-row tw-items-center tw-justify-start tw-py-2 tw-px-2.5 tw-mt-1 tw-gap-[10px] tw-text-sm tw-text-slategray tw-border-[1px] tw-border-solid tw-border-whitesmoke-200'>
                        <label className='tw-flex-1 tw-relative focus:tw-outline-none' >
                            {connector?.name ?? ''}
                        </label>
                    </div>
                    <button aria-label="Delete" data-testid="components-connectorconfigurations-button-2" onClick={() => handleDeleteField(index)}>
                        <DeleteIcon />
                    </button>
                </div>)}
            </div>
            {showConnectorMenu ? <ImportSubmodel showConnectorMenu={showConnectorMenu} setShowConnectorMenu={setShowConnectorMenu} userProjectDataModels={userProjectDataModels} setConnectorConfiguration={setConnectorConfiguration} selectedItem={selectedItem} /> : null}
        </div>
    );
}

export default ConnectorConfigurations;